import React from 'react';
import "./ThankYou.css";
import ThankYouImg from "../assets/thank_you.svg";

const ThankYou = () => {
  return (
    <div className='thanks fdc'>
        <img src={ThankYouImg} alt="Thank You" className='fs48'/>
        <p className='mt16 fs16 ls1 lh18 fc3'>Thank you for sharing your experience with us!</p>
    </div>
  )
}

export default ThankYou
